import React, {Component} from "react";
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { global } from './../../config.js';
import withRouter from './../withRouter';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Image from 'react-bootstrap/Image';

import ClipLoader from "react-spinners/ClipLoader";
import BarLoader from "react-spinners/BarLoader";


class Photo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params.id,
            item: {},
            loading: true,
            error: false,
            show_modal_delete: false,
            photo: null,
            uploading: false
        };

        this.item = this.item.bind(this)
        this.handleCloseDelete = this.handleCloseDelete.bind(this)
        this.delete = this.delete.bind(this)
    }

    componentDidMount(){
        this.item()
    }

    item() {
        
        const requestOptions = {
            method: 'GET',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items/' + this.state.id, requestOptions)
        .then(res => res.json().then(
            (result) => {

                if (res.status === 200 && !result.error) {
                    this.setState({
                        item: result,
                        loading: false,
                        photo: result.photo
                    });
                } else {
                    if (result.error) {
                        this.setState({
                            error: result.error.message
                        });
                    } else {
                        this.setState({
                            error: "Произошла ошибка. Пожалуйста, попробуйте позже."
                        });
                    }
                }
                this.setState({
                    loading: false
                });
            }
        ))

    }


    delete() {

        this.setState({
            deleting: true,
            error: false
        })

        const requestOptions = {
            method: 'DELETE',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items/' + this.state.id + "/photo", requestOptions)
            .then(res => res.json().then(
            (result) => {
                if (res.status === 200 && !result.error) {
                    this.setState({
                        photo: null,
                    });
                } else if (result.error) {
                    this.setState({
                        error: result.error.message
                    });
                } else {
                    this.setState({
                        error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                    });
                }

                this.setState({
                    deleting: false,
                    show_modal_delete: false
                });
            },
            (error) => {}
        ))
    }


    handleCloseDelete() {
        this.setState({
            show_modal_delete: false
        })
    }

    handleFileChange = event => {
        const file = event.target.files[0]

        this.setState({
            uploading: true,
            error: false
        })

        const formData = new FormData();
        formData.append('file', file, file.name);
            
        fetch(global.endpoint_api + '/items/' + this.state.id + "/photo", {
          method: 'PUT',
          body: formData,
          headers: {
            'Authorization': 'Bearer ' + Cookies.get('session-acs'),
            "Access-Control-Allow-Origin": "*"
          },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.Location)
                this.setState({
                    uploading: false,
                    photo: data.Location
                });
            else {
                this.setState({
                    uploading: false,
                    error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                });
            }
          })
          .catch((err) => {
            console.error(err)
            this.setState({
                uploading: false,
                error: err
            });
          });
    };
    


    render() {

        let { item, photo, loading, show_modal_delete, deleting, uploading, error } = this.state

        return (
            <>
            <Row className="mb-4">
                <Col>
                    <Link to={"/items/" + this.state.id}>&larr; Назад</Link>
                </Col>
            </Row>
            <Row>
                <Col md={9} lg={6}>
                    <ClipLoader
                        loading={loading}
                        size={30}
                    />
                    {!item.title && !loading && (
                        <h4>Объект не найден или был удален</h4>
                    )}

                    {item.title && !loading && (
                        <>
                            <div className="mb-5">

                                <div className="card card-simple">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h5><Image src="/images/icons/photo.svg" width={20}/> Фото</h5>
                                            {photo === null && (
                                                <p className="small truncate-text-lines">Не добавлено</p>
                                            )}
                                            {photo != null && (
                                                <Image className="cover-preview mt-4" src={photo} alt="Фото" />
                                            )}
                                        </div>

                                        <Row className="mb-4 justify-content-between">

                                            <Col>
                                                {photo === null && !uploading && (
                                                    <>
                                                        <label className="btn btn-sm btn-dark" htmlFor="file-upload">
                                                            Загрузить файл
                                                        </label>
                                                        <input
                                                            className="input-file"
                                                            type="file"
                                                            id="file-upload"
                                                            onChange={this.handleFileChange}
                                                            accept="image/*"
                                                        />
                                                    </>
                                                )}
                                                 
                                                <BarLoader color="#0b2621" loading={uploading}/>
                                         
                                            </Col>
                                        </Row>
                                    
                                    </div>
                                </div>

                            </div>

                            {photo != null && (
                                <Link to="#" className="text-danger"onClick={() => this.setState({show_modal_delete: true})}>Удалить фото</Link>
                            )}

                            <Modal show={show_modal_delete} onHide={this.handleCloseDelete} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Удалить</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Вы действительно хотите удалить фото?</p>
                                </Modal.Body>
                                <Modal.Footer className="justify-content-between">
                                    <Button variant="light" disabled={deleting} onClick={this.handleCloseDelete}>
                                        Нет
                                    </Button>
                                    <Button variant="danger" disabled={deleting} onClick={this.delete}>
                                        Да
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            
                        </>
                    )}

                    {error && (
                        <p className="text-danger">{error}</p>
                    )}
                    
                </Col>
            </Row>
            </>
        )

    }
}

export default withRouter(Photo);